/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResetPccPushStatus200ResponseData } from './ResetPccPushStatus200ResponseData';
import {
    ResetPccPushStatus200ResponseDataFromJSON,
    ResetPccPushStatus200ResponseDataFromJSONTyped,
    ResetPccPushStatus200ResponseDataToJSON,
    ResetPccPushStatus200ResponseDataToJSONTyped,
} from './ResetPccPushStatus200ResponseData';

/**
 * 
 * @export
 * @interface ResetPccPushStatus200Response
 */
export interface ResetPccPushStatus200Response {
    /**
     * 
     */
    data?: ResetPccPushStatus200ResponseData;
}

/**
 * Check if a given object implements the ResetPccPushStatus200Response interface.
 */
export function instanceOfResetPccPushStatus200Response(value: object): value is ResetPccPushStatus200Response {
    return true;
}

export function ResetPccPushStatus200ResponseFromJSON(json: any): ResetPccPushStatus200Response {
    return ResetPccPushStatus200ResponseFromJSONTyped(json, false);
}

export function ResetPccPushStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPccPushStatus200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ResetPccPushStatus200ResponseDataFromJSON(json['data']),
    };
}

export function ResetPccPushStatus200ResponseToJSON(json: any): ResetPccPushStatus200Response {
    return ResetPccPushStatus200ResponseToJSONTyped(json, false);
}

export function ResetPccPushStatus200ResponseToJSONTyped(value?: ResetPccPushStatus200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ResetPccPushStatus200ResponseDataToJSON(value['data']),
    };
}

